module.exports = {
	"articleTitle1": "Best Pizza: Mani Osteria ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Mani Osteria & Bar",
	"articleLink1": "https://www.michigandaily.com/section/arts/best-pizza-mani-osteria",
	"articleLink2": "https://www.michigandaily.com/arts/11chef-profile-brendan-mccall06",
	"articleSnippet1": "Apr 4, 2016 ... As you walk into the sleek, modern restaurant space at Mani, the heat from the \nwood-fired oven slowly radiates out, and you know you've found ...",
	"articleSnippet2": "Nov 5, 2014 ... He's now the executive chef at both Mani Osteria and Isalita, two wildly popular \nrestaurants on East Liberty that are favorites of both reviewers ...",
	"foodRecommendations": [
		{
			"text": "They have really good pizza, but it's super expensive",
			"peson": "Maria Iaderosa"
		}
	],
	"articleTitle2": "Chef Profile: Brendan McCall enjoys diverse successes after return ...",
	"address": "341 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/agc.NEW_.ManiOsteriaBOAA.3.31.16.021.jpg?itok=h1hr3Mr6",
			"author": "Amelia Cacchione",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279718,
		"lng": -83.744275
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/maniosteria.json
// module id = 911
// module chunks = 0